import store from './vuex/store'
import { addListing, getUserToken } from './functions.js'
import { saveListingEdit } from './listingsRepository.js'
import axios from 'axios'
import { getServerApi } from './config/deployment'
import { getCurrentUserToken } from './platform/auth/services/authService.js'

let envUri = getServerApi()
let uri = envUri + '/api/listings/maakler'
let listingV2Uri = envUri + '/api/listings/v2/ids';
const PROPERTIES_ENDPOINT = `${envUri}/api/listings/v2/properties`;

const STATUS_TO_ACTION_MAP = Object.freeze({
  active: 'APPEND_ACTIVE_PROPERTIES',
  draft: 'APPEND_DRAFT_PROPERTIES',
  archived: 'APPEND_ARCHIVED_PROPERTIES',
});

export const getDisplayStatus = (status) => {
  if (status == "draft") return ""
  if (status == "active") return "Live"
  if (status == "archived") return "Archived"
  return ""
}

export const getDisplayAddress = (data) => {
  if (!data.location.address) return 'Specify address in Edit'
  if (data.location.address.apartNumber && data.location.address.municipality)
    return data.location.address.municipality + ', ' + data.location.address.street + ' ' + data.location.address.number + ' - ' + data.location.address.apartNumber
  else if (data.location.address.municipality)
    return data.location.address.municipality + ', ' + data.location.address.street + ' ' + data.location.address.number
  else
    return data.location.address.street + ' ' + data.location.address.number
}


export const getProperties = async (status, errors, meta, pageNumber = 0, pageLimit = 30) => {
  try {

    // WARN/TODO: selectedAccount is not set yet here
    let accountId = store.getters.selectedAccount
    
    store.commit('setPropertiesRequestPending', true);
    let propsInStore;
    if (status == "active") {
      propsInStore = store.getters.activeProperties;
    }
    else if (status == "draft") {
      propsInStore = store.getters.draftProperties;
    }
    else if (status == "archived") {
      propsInStore = store.getters.archivedProperties;
    }
    else return;

    resetState(meta, errors)
    if (propsInStore.length <= 0) {
      //if storage is empty, download from server
      // await loadListingsFromServerAndSaveToStorage([status], errors, meta);
    }
    const actionName = getActionNameByStatus(status);
    if (!actionName) {
      return;
    }
    const properties = await getPropertiesByStatus(status, pageNumber, pageLimit, accountId);
    store.commit('setPropertiesRequestPending', false);
    if (!properties) {
      return;
    }
    store.dispatch(actionName, properties);
  }
  catch (error) {
    throw error;
  }
  finally {
    meta.splice(0, 1, { listingProgress: 100 });
    store.commit('setPropertiesRequestPending', false);
  }
};

export const filterProperties = ({ searchString, status = null, page = 0, limit = 250, accountId = null }) => {
  return getFilteredProperties({ searchString, status, page, limit, accountId });
};

function resetState(meta, errors) {
  meta.splice(0, 1, { listingProgress: 0 })
  errors.splice(0, errors.length)
}


export const orderListingsByModDate = (listings) => {
  try {
    function compare(a, b) {
      const listingA = a.creationDet.lstModDate
      const listingB = b.creationDet.lstModDate

      let comparison = 0;
      if (listingA < listingB) {
        comparison = 1;
      } else if (listingA > listingB) {
        comparison = -1;
      }
      return comparison;
    }
    return listings.sort(compare)
  } catch (err) {
    return listings
  }
}

export const setListingToBeReloadedUponDashboardVisit = (id, prevStatus, newStatus) => {
  sessionStorage.setItem('refreshListingId', id)
  sessionStorage.setItem('refreshListingPrevStatus', prevStatus)
  sessionStorage.setItem('refreshListingNewStatus', newStatus)
}


export const getAllDashboardListingIds = (listingStatus) => {
  return getAllDashboardListingIdsActual(listingStatus)
}

export const getDashboardListing = (userUid, listingMaaklerId, indexToPutResult) => {
  return getDashboardListingActual(userUid, listingMaaklerId, indexToPutResult)
}

function getAllDashboardListingIdsActual(statuses) {
  return getUserToken()
    .then(res => {
      var data = {
        token: res,
        listingStatuses: statuses
      }
      return axios.post(listingV2Uri, data)
        .then(response => {
          if (response.status === 200 && response.data.body)
            return response.data.body
          else
            throw new Error("Cannot get all dashboard listing ids");
        })
        .catch(err => {
          return false
        })
    })
}

function getDashboardListingActual(userUid, listingMaaklerId, indexToPutResult) {
  return new Promise((resolve, reject) => {
    getUserToken()
      .then(res => {
        var data = {
          token: res,
          listingId: listingMaaklerId,
          id: userUid
        }
        axios.post(uri + '/dashboard', data)
          .then(response => {
            if (response.status === 200 && response.data.body) resolve(response.data.body)
            else throw new Error("Cannot get dashboard listings");
          })
          .catch(err => {
            reject()
          })
      })
  })
}


export const updateListingParts = (updateTheseParts) => {
  return new Promise((resolve, reject) => {
    if (store.getters.listingProgress == "LISTING_ADDED") {
      update(updateTheseParts).then(response => {
        resolve(response)
      })
    } else if (store.getters.listingProgress == "LISTING_PENDING") {
      reject("try again in a moment")
    } else {
      var obj = store.getters.listing;
      setCreationDetails(obj);
      add(obj)
        .then(response => {
          resolve(response)
          console.log('response:', response);

        })
        .catch(err => {
          console.log('err:', err);
        })
    }
  })
}

function setCreationDetails(listing) {
  listing.creationDet.createdDate = new Date();
  listing.creationDet.lstModDate = new Date();
  listing.creationDet.createdBy = store.getters.user.uid;
  listing.creationDet.lstModBy = store.getters.user.uid;
  listing.owner.uid = store.getters.user.uid;
  listing.owner.accountId = store.getters.selectedAccount;
}

function createAddListingObject() {
  return {
    location: store.getters.location,
    googLocation: store.getters.googLocation,
    techDet: store.getters.techDet,
    txnDet: store.getters.txnDet,
    marketingDet: store.getters.marketingDet,
    genDet: store.getters.genDet,
    availDet: store.getters.availDet,
    creationDet: {
      createdDate: store.getters.listingCreationDate,
      lstModDate: '',
      createdBy: store.getters.userUIdWhoIsAddingListing,
      lstModBy: store.getters.userUIdWhoIsAddingListing
    },
    owner: {
      uid: store.getters.userUIdWhoIsAddingListing
    }
  }
}

let update = (object) => {
  store.commit('LISTING_PENDING')
  let objectId = store.getters.addedListingObjectId
  if (objectId) {
    return saveListingEdit(object, objectId)
      .then(result => {
        store.commit('LISTING_ADDED', objectId)
        return true
      }).catch(err => {
        store.commit('LISTING_ADDED', objectId)
        return false
      })
  }
  else {
    store.commit('LISTING_ADDED', objectId)
    return false
  }

}

let add = (obj) => {
  store.commit('LISTING_PENDING')
  return addListing(obj)
    .then(result => {
      if (result.body.ObjectId) store.commit('LISTING_ADDED', result.body.ObjectId)
      return true
    }).catch(err => {
      store.commit('LISTING_NOT_ADDED')
      return false
    })
}

const getPropertiesByStatus = async (status, pageNumber = 0, pageLimit = 30, accountId) => {
  const token = await getCurrentUserToken();
  const response = await axios.get(PROPERTIES_ENDPOINT, {
    params: {
      token,
      status,
      page: pageNumber,
      limit: pageLimit,
      accountId: accountId
    },
  });

  return response.data.body;
};

const getFilteredProperties = async ({ searchString, page = 0, limit = 30, status = null, accountId = null }) => {
    const token = await getUserToken();
    const response = await axios.get(`${PROPERTIES_ENDPOINT}/filter`, {
      params: {
          token,
          searchString,
          status,
          page,
          limit,
          accountId,
      },
    });

    return response.data.body;
};

const getActionNameByStatus = (status) => {
  return STATUS_TO_ACTION_MAP[status] || null;
};


// WEBPACK FOOTER //
// ./src/listingFunctions.js